"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Option = /** @class */ (function () {
    function Option() {
        this.label = '';
        this.value = '';
        this.isDisabled = false;
    }
    return Option;
}());
exports.default = Option;
//# sourceMappingURL=Option.js.map